(function iefe(w, d) {
    const images = d.querySelectorAll('.Result__image img');
    images.forEach((image) => {
        const realWidth = image.naturalWidth;
        const realHeight = image.naturalHeight;
        const aspect = `${realWidth} / ${realHeight}`;
        if (realWidth > realHeight) {
            image.classList.add('wide');
            // eslint-disable-next-line no-param-reassign
            image.style.aspectRatio = aspect;
        } else {
            image.classList.add('tall');
            // eslint-disable-next-line no-param-reassign
            image.style.aspectRatio = aspect;
        }
    });
}(window, document));
